import $ from 'jquery';

export default function(membershipType) {
  let $input;

  if (membershipType === 'BASIC') {

    $input = $('<input type="text" name="unregistered-birth-year" title="Birth Year" data-dob="unregistered-birth-year" placeholder="Birth Year (YYYY)*" pattern="[0-9]{4}" required tabindex="3" />');
  } else {

    $input = $('<input type="text" name="unregistered-dob" title="Birth Date" data-dob="unregistered-dob" placeholder="Birth Date (MM/DD/YYYY)*" pattern="[0,1]?[0-9]/[0-3]?[0-9]/[1,2][9,0][0-9]{2}" required tabindex="3" />');
  }

  $('.dob-wrapper').html($input);

  return $input;

}